import {useGameServerConnection} from '@glark-newco/game-library';
import {Button, Group} from '@mantine/core';
import {IconPlayerPlay} from '@tabler/icons-react';
import {DisplayPlayScenePayload, SupplyChainPayload} from '../SupplyChainPayloadTypes';

export function DisplayPlaySceneButton() {
    const {publishPlayerAction} = useGameServerConnection<SupplyChainPayload>();

    function publishDisplayPlaySceneEvent() {
        publishPlayerAction({
            type: 'displayPlayScene',
        } as DisplayPlayScenePayload);
    }

    return (
        <Group
            data-testid="facilitator-actions"
            style={{
                width: '20%',
                position: 'absolute',
                pointerEvents: 'initial',
                right: '1rem',
                top: '7rem',
            }}
        >
            <Button
                rightSection={<IconPlayerPlay size={14}/>}
                radius={'xl'}
                variant="gradient"
                onClick={() => publishDisplayPlaySceneEvent()}
                gradient={{from: 'blue', to: 'teal', deg: 90}}
                size={'lg'} bd={'0.15em solid white'}
            >
                Return to view network
            </Button>
        </Group>
    );
}
